module.exports = __webpack_public_path__ + "img/matrix-layer.07c403de.svg";